import React, { Fragment } from 'react';
import { SectionDivider, ActionsWrapper, Form } from '@contently/toolkit';
import { FieldArray } from 'formik';
import DynamicInput from './DynamicInput';
import fileShouldRender from './fieldShouldRender';
import useDynamicFormikFetchingApi from './useDynamicFormikFetchingApi';
import getNestedAttrs from '../../../utils/getNestedAttrs';
import ErrorNotice from '../error_notice';

export const FormikHandlersContext = React.createContext({});

function DynamicFormikForm(props) {
  const {
    config,
    handleSubmit,
    values,
    errors,
    handleBlur,
    handleChange,
    touched,
    setFieldValue,
    setFieldTouched,
    record,
    isSubmitting,
    ...remainingProps
  } = props;

  const [fetchingState, fetchingApi] = useDynamicFormikFetchingApi(config, record);

  const readableValues = getNestedAttrs(values);
  const readableErrors = getNestedAttrs(errors);
  const readableTouched = getNestedAttrs(touched);

  const renderFields = () => {
    return config.fields.map(field => {
      if (!fileShouldRender(field, record)) {
        return <Fragment />;
      }

      if (typeof field.customRender === 'function') {
        const customRenderProps = {
          key: field.id,
          ...props,
          values: readableValues,
          errors: readableErrors,
          touched: readableTouched,
          ...field
        };
        return field.customRender(customRenderProps);
      }

      if (!(field.id in readableValues)) {
        console.warn(`The field with id ${field.id} does not have a value in the Formik setup`);
      }

      return (
        <DynamicInput
          key={field.id}
          value={readableValues.get(field.id)}
          required={field.required}
          label={field.label}
          errors={readableErrors.get(field.id)}
          touched={readableTouched.get(field.id)}
          record={record}
          {...remainingProps}
          {...field}
        />
      );
    });
  };

  const handlersContext = {
    handleBlur,
    handleChange,
    setFieldValue,
    setFieldTouched,
    fetchingApi,
    isFetching: Object.keys(fetchingState).filter(id => fetchingState[id].fetching).length > 0
  };

  const fetchingError = Object.keys(fetchingState).filter(id => fetchingState[id].error).length > 0;
  if (fetchingError) {
    const defaultMsg = 'There was an error loading your form.';
    return <ErrorNotice msg={defaultMsg} />;
  }

  return (
    <form onSubmit={handleSubmit} data-parsley-excluded="true">
      <FormikHandlersContext.Provider value={handlersContext}>
        <SectionDivider>
          <FieldArray name="" render={renderFields} />
        </SectionDivider>
        <ActionsWrapper>
          <Form.CancelLinkButton href={config.cancelLinkLocation(props)} />
          <Form.ButtonWithProgress type="submit" disabled={isSubmitting} variant="primary">
            Save
          </Form.ButtonWithProgress>
        </ActionsWrapper>
      </FormikHandlersContext.Provider>
    </form>
  );
}

export default DynamicFormikForm;



// WEBPACK FOOTER //
// ./app/javascript/app/components/forms/dynamic_forms/DynamicFormikForm.jsx